import { render } from "./TeacherCard.vue?vue&type=template&id=23ea33d8&scoped=true"
import script from "./TeacherCard.vue?vue&type=script&lang=js"
export * from "./TeacherCard.vue?vue&type=script&lang=js"

import "./TeacherCard.vue?vue&type=style&index=0&id=23ea33d8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ea33d8"]])

export default __exports__